"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const DefaultClassUtil_1 = __importDefault(require("modules/classManager/DefaultClassUtil"));
require("./drippingApi");
const constants_1 = require("../constants");
const request_1 = __importDefault(require("@hotmart/request"));
class DrippingService {
    constructor() {
        this.removeDrippingBulk = (payload) => {
            return (0, request_1.default)(constants_1.DrippingEndpointKeys.RemoveBulk, payload);
        };
        this.postDrippingBulk = (payload) => {
            return (0, request_1.default)(constants_1.DrippingEndpointKeys.PostBulk, payload);
        };
        this.fetchModuleClasses = async (moduleId) => {
            const response = await (0, request_1.default)(constants_1.DrippingEndpointKeys.GetModuleClasses, {
                moduleId
            });
            return response.map((item) => ({
                ...item,
                name: DefaultClassUtil_1.default.getName(item.name)
            }));
        };
        this.fetchProductClasses = async () => {
            const response = await (0, request_1.default)(constants_1.DrippingEndpointKeys.GetProductClasses);
            return response.content.map(({ id, name, defaultClass }) => ({
                id,
                name: DefaultClassUtil_1.default.getName(name),
                defaultClass
            }));
        };
    }
    fetchQuizzesByModule(moduleId) {
        return (0, request_1.default)(constants_1.DrippingEndpointKeys.GetQuizzes, {
            moduleId
        });
    }
    async fetchQuizDetails(pageId) {
        const response = await (0, request_1.default)(constants_1.DrippingEndpointKeys.GetQuizDetails, { pageId });
        return response;
    }
}
exports.default = new DrippingService();
